<template>
  <div class="close_box">
    <img
      class="close_icon"
      src="@/assets/img/mobile-img/extend-success.png"
      alt=""
    />
    <h3 class="close_title">恭喜您，已开通成功</h3>
    <p class="close_reason">现在您可通过推广市场，进行推广商品赚取佣金</p>
    <van-button
      round
      type="info"
      class="btn"
      @click="$router.replace('/extend/extend-market')"
      >进入推广市场</van-button
    >
  </div>
</template>
  
  <script>
export default {
  data() {
    return {
      reason: "",
    };
  },
  created() {
    this.getReason();
  },
  methods: {
    async getReason() {
      let res = await this.$apis.extendServe.hasExtendLimits();
      if (res.resultCode === "200") {
        this.reason = res.data.closeReason;
      }
    },
  },
};
</script>
  
  <style scoped lang="scss">
.close_box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 0 15px;
  background-color: #fff;
  min-height: calc(100vh - 44px);
  //   text-align: center;
  .close_icon {
    width: 85px;
    height: 85px;
  }
  .close_title {
    margin-top: 19px;
    font-size: 15px;
    color: #333333;
    line-height: 21px;
  }
  .close_reason {
    margin-top: 12px;
    padding: 0 74px;
    font-size: 13px;
    color: #999999;
    line-height: 20px;
  }
  .btn {
    margin-top: 38px;
    width: 210px;
    height: 44px;
    border-radius: 22px;
  }
}
</style>